<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six">
        <div>
          <div class="title_div">
            <span class="title-span">榜单:</span>
            <el-select
              clearable
              size="small"
              class="title-select"
              v-model="rbParams.listId"
              @change="listTypeChange"
            >
              <el-option
                v-for="item in this.rankingList"
                :label="item.listName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span class="title-span">弓种:</span>
            <el-select
              clearable
              size="small"
              class="title-select"
              v-model="rbParams.bowType"
              @change="bowTypeChange"
            >
              <el-option
                v-for="item in this.bowTypeList"
                :label="item.title"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <span class="title-span">米数:</span>
            <el-select
              clearable
              size="small"
              class="title-select"
              v-model="rbParams.meterType"
              @change="meterTypeChange"
            >
              <el-option
                v-for="item in this.meterTypeList"
                :label="item.title"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <span class="title-span">日期:</span>
            <el-date-picker
              v-model="rbParams.listDate"
              @change="dateChange"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="copyAll"
              >批量导出
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="rbList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="listName" label="榜单" align="center">
              </el-table-column>
              <el-table-column prop="bowType_text" label="弓种" align="center">
              </el-table-column>
              <el-table-column
                prop="meterType_text"
                label="米数"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="listDate" label="日期" align="center">
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="editRb(scope.row)"
                    >成绩</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="rbSizeChange"
              @current-change="rbCurrentChange"
              :current-page="rbResult.current"
              :page-size="rbResult.size"
              layout="total,prev, pager, next, sizes"
              :total="rbResult.total"
                :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="editDialogVisible"
      width="40%"
      style="text-align: center"
      :close-on-click-modal="false"
    >
      <span style="font-size: 20px">{{ title }}</span>
      <div style="margin-top: 20px">
        <el-table :data="xqList" style="width: 100%">
          <el-table-column
            prop="ranking"
            label="选手名次"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="memberName" label="选手姓名" align="center">
          </el-table-column>
          <el-table-column prop="memberScore" label="选手成绩" align="center">
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="seeRb(scope.row.memberPhoto)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="图片查看"
      :visible.sync="photoDialogVisible"
      width="700px"
      style="text-align: center"
      :close-on-click-modal="false"
    >
      <el-image
        v-for="(item, index) in this.photoList"
        lazy
        style="width: 200px; height: 200px; margin: 10px"
        :src="item"
        :key="index"
        :preview-src-list="photoList"
      >
      </el-image>
    </el-dialog>
  </div>
</template>

<script>
import {
  bowType,
  meterType,
  getRankingListForSelect,
  getAntRankingListDayScoreDetail,
  getAntRankingListDayScoreList,
  getGameInfo,
  getAntRankingListDayScoreListForExcel,
} from "../../api/OperationManagement";
import { globelurl } from "../../api/axios";

export default {
  name: "6ListManagement",
  data() {
    return {
      activeName: "six",
      titleUrl: globelurl,
      bowTypeList: [],
      meterTypeList: [],
      rankingList: [],
      rbList: [],
      rbResult: {},
      title: "",
      xqList: [],
      rbParams: {
        bowType: "",
        listId: "",
        meterType: "",
        listDate: "",
        pageNo: 1,
        pageSize: 10,
      },
      editDialogVisible: false,
      photoDialogVisible: false,
      photoList: [],
    };
  },
  mounted() {
    this.getAntRankingListDayScoreList(this.rbParams);
    this.bowType();
    this.meterType();
    this.getRankingListForSelect();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        // this.$router.push('/OperationManagement/6ListManagement');
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    rbSizeChange(newSize) {
      this.rbParams.pageSize = newSize;
      this.getAntRankingListDayScoreList(this.rbParams);
    },
    rbCurrentChange(newPage) {
      this.rbParams.pageNo = newPage;
      this.getAntRankingListDayScoreList(this.rbParams);
    },
    //榜单下拉更改
    listTypeChange() {
      this.rbParams.pageNo = 1;
      this.getAntRankingListDayScoreList(this.rbParams);
    },
    //弓种下拉更改
    bowTypeChange() {
      this.rbParams.pageNo = 1;
      this.getAntRankingListDayScoreList(this.rbParams);
    },
    //米数下拉更改
    meterTypeChange() {
      this.rbParams.pageNo = 1;
      this.getAntRankingListDayScoreList(this.rbParams);
    },

    //日期下拉更改
    dateChange() {
      this.rbParams.pageNo = 1;
      this.getAntRankingListDayScoreList(this.rbParams);
    },
    // 获取弓种字典
    bowType() {
      bowType().then((res) => {
        if (res.data.success) {
          this.bowTypeList = res.data.result;
        }
      });
    },
    // 获取米数字典
    meterType() {
      meterType().then((res) => {
        if (res.data.success) {
          this.meterTypeList = res.data.result;
        }
      });
    },
    // 获取日榜下拉列表
    getRankingListForSelect() {
      getRankingListForSelect().then((res) => {
        if (res.data.success) {
          this.rankingList = res.data.result;
        }
      });
    },
    //日榜列表查询
    getAntRankingListDayScoreList(params) {
      getAntRankingListDayScoreList(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.rbResult = res.data.result;
            this.rbList = res.data.result.records;
          } else {
            this.rbResult = res.data.result;
            this.rbList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑日榜
    editRb(val) {
      this.title = val.listName;
      getAntRankingListDayScoreDetail({
        listId: val.listId,
        listDate: this.rbParams.listDate
          ? this.rbParams.listDate
          : val.listDate,
      }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.xqList = res.data.result;
            this.editDialogVisible = true;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //查看图片列表
    seeRb(photo) {
      const imgList = photo.split(",");
      this.photoList = [];
      imgList.forEach((itm) => {
        this.photoList.push(this.titleUrl + itm);
      });

      this.photoDialogVisible = true;
    },
    //批量导出
    copyAll() {
      getAntRankingListDayScoreListForExcel(this.rbParams).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "日榜"; // sessionStorage.realName + timestr　　　　　　　　// xxx.xls/xxx.xlsx
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>
